import { Box, Typography, IconButton, Tooltip, useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import RoleBasedAccess from "../../services/RoleBasedAccess";
import { Vehicle } from "../../state/types";
import { useNavigate } from "react-router-dom";
import { downloadFilesAsync } from "../../services/FileDownloader";

interface VehicleHeaderProps {
  vehicle: Vehicle;
}

const VehicleHeader: React.FC<VehicleHeaderProps> = ({ vehicle }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        borderBottom: `solid 5px ${theme.palette.divider}`,
        py: 1,
      }}
    >
      <Typography variant="h4" sx={{ textAlign: "center" }}>
        {vehicle.vin}
      </Typography>

      <Box
        sx={{
          position: "absolute",
          right: 16,
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        <RoleBasedAccess allowedRoles={["Admin", "Support", "Auditor"]}>
          <Tooltip title="Edit Vehicle">
            <IconButton
              sx={{ backgroundColor: theme.palette.primary.main }}
              onClick={() => navigate("edit", { state: { vehicle } })}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </RoleBasedAccess>

        <Tooltip title="Download Images">
          <IconButton
            sx={{ backgroundColor: theme.palette.error.main }}
            onClick={() => downloadFilesAsync(vehicle)}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default VehicleHeader;
